module.exports = __webpack_public_path__ + "static/media/05cheliangjianxiugong2.582528d0.png";